module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group clearfix"
  }, [_c('button', {
    class: ['btn', 'btn-w', 'left'],
    domProps: {
      "textContent": _vm._s(_vm.lng.reset)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetData.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    class: ['btn', 'btn-w', 'right'],
    domProps: {
      "textContent": _vm._s(_vm.lng.save)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveData.apply(null, arguments)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/PhpstormProjects/e-crewing/~/vue-loader/lib/template-compiler.js?id=data-v-ab915bf2!C:/PhpstormProjects/e-crewing/~/vue-loader/lib/selector.js?type=template&index=0!./vue/frontfilter/components/Buttons.vue
// module id = 184
// module chunks = 1